import { render, staticRenderFns } from "./MyAvailability.vue?vue&type=template&id=1471c56d&"
import script from "./MyAvailability.vue?vue&type=script&lang=js&"
export * from "./MyAvailability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports